<template>
	<div class="my">
		<!-- 顶部 -->
		<section class="myTop">
			<div class="avater">
				<img v-if="userInfo.wxFace != ''" :src="userInfo.wxFace" alt="">
				<img v-else src="../assets/avater.jpeg" alt="">
			</div>
			<div class="naickname">
				<span>{{userInfo.wxNick= ''?userInfo.wxNick:'用户昵称'}}</span>
				<span>{{userInfo.phone}}</span>
			</div>
		</section>
		<!-- 列表 -->
		<section class="myList">
			<div class="mylistItem">
				<h2 class="listTitle">订单中心</h2>
				<ul>
					<li v-for="(item,index) in listArr" :key="index"
						@click="$router.push({ path: item.url,query:{orderType:item.id}})">
						<p>{{item.name}}订单</p>
						<img src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/corner-right.png" alt="">
					</li>
				</ul>
			</div>
			<div class="mylistItem">
				<h2 class="listTitle">会员中心</h2>
				<ul>
					<li @click="$router.push({ path: '/shop'})">
						<p>积分商城</p>
						<img src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/corner-right.png" alt="">
					</li>
					<li @click="$router.push({ path: '/integral'})">
						<p>我的积分</p>
						<img src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/corner-right.png" alt="">
					</li>
					<li @click="$router.push({ path: '/myCoupons'})">
						<p>优惠券</p>
						<img src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/corner-right.png" alt="">
					</li>
					<li @click="$router.push({ path: '/voucherList'})">
						<p>兑换券</p>
						<img src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/corner-right.png" alt="">
					</li>
					<li @click="$router.push({ path: '/travelList'})">
						<p>出行人列表</p>
						<img src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/corner-right.png" alt="">
					</li>
				</ul>
			</div>
		</section>
		<div style="width: 100%;height: 60px;"></div>
		<!-- 导航 -->
		<section class="tabbar">
			<Footer :active="meActive" />
		</section>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import {
		Dialog
	} from 'vant'
	import Footer from '@/components/Footer.vue'
	export default {
		name: 'my',
		components: {
			Footer
		},
		data() {
			return {
				meActive: 1,
				listArr: [{
						name: '景点门票',
						id: 1,
						url: '/orderList'
					},
					{
						name: '定制 & 周边游',
						id: 2,
						url: '/groupOrder'
					},
					// {
					// 	name: '星球少年',
					// 	id: 8,
					// 	url: '/orderList'
					// },
					// {
					// 	name: '自由行',
					// 	id: 3
					// },
					// {
					// 	name: '邮轮游',
					// 	id: 4,
					// 	url: "/cruiseOrderList"
					// },
					// {
					//   name: '定制游',
					//   id: 7
					// },
					// {
					// 	name: '签证',
					// 	id: 5,
					// 	url: "/orderList"
					// },
					// {
					// 	name: '秒杀',
					// 	id: 6
					// },
				],
			}
		},
		computed: {
			...mapGetters('account', ['userInfo', 'refundApplyDetail'])
		},
		mounted() {
			if (this.refundApplyDetail) {
				localStorage.removeItem('refundApplyDetail')
			}
			if (!this.userInfo.userId) {
				Dialog.alert({
					title: '温馨提示',
					message: '用户信息已过期，请重新登录！',
				}).then(() => {
					// on close
				});
			}
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#f2f2f2')
		}
	}
</script>

<style scoped>
	.myTop {
		width: 100%;
		height: 290px;
		background-color: #ffc730;
		display: flex;
		padding: 30px 30px;
		box-sizing: border-box;
	}

	.avater {
		background-color: #fff;
		border-radius: 50%;
		width: 140px;
		height: 140px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.avater img {
		width: 120px;
		height: 120px;
		border-radius: 50%;
	}

	.naickname {
		display: flex;
		flex-direction: column;
		color: #fff;
		font-size: 30px;
		padding-left: 20px;
		box-sizing: border-box;
		line-height: 48px;
		margin-top: 10px;
	}

	.myList {
		width: 100%;
		padding: 0 30px;
		box-sizing: border-box;
		margin-top: -80px;
	}

	.mylistItem {
		background-color: #fff;
		border-radius: 20px;
		padding: 0 30px;
		box-sizing: border-box;
		margin-bottom: 20px;
	}

	.mylistItem li {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		height: 90px;
		border-top: #f2f2f2 1px solid;
	}

	.mylistItem li img {
		width: 10px;
		height: 18px;
	}

	.listTitle {
		height: 90px;
		width: 100%;
		line-height: 90px;
		font-size: 34px;
		font-weight: bold;
		color: #333;
	}
</style>